
function Footer() {
    // return <footer className='py-2 w-full bg-slate-800 fixed bottom-0'>
    //     <div className='text-center text-white text-xs'>Made with ❤️ by <a href="http://www.ronanmiguelkelly.com/">RMK</a></div>
    // </footer>
    return <div/>
}


export default Footer